import { Link, useParams } from "@tanstack/react-router";
import clsx from "clsx";
import { SlidersHorizontal, Filter as FilterIcon, Ban, Plane, ShieldCheck, Keyboard, Activity, Signature as SignatureIcon } from "lucide-react";
import { GeneralSection } from "./GeneralSection";
import { FiltersSection } from "./FiltersSection";
import { BlockedSection } from "./BlockedSection";
import { VacationSection } from "./VacationSection";
import { SecuritySection } from "./SecuritySection";
import { KeyboardSection } from "./KeyboardSection";
import { MailHealthSection } from "./MailHealthSection";
import { SignaturesSection } from "./SignaturesSection";
import { useSession } from "../../lib/queries";
import s from "./Settings.module.css";

const SECTIONS = [
  { id: "general", label: "General", icon: SlidersHorizontal, view: GeneralSection },
  { id: "signatures", label: "Signatures", icon: SignatureIcon, view: SignaturesSection },
  { id: "filters", label: "Filters", icon: FilterIcon, view: FiltersSection },
  { id: "blocked", label: "Blocked addresses", icon: Ban, view: BlockedSection },
  { id: "vacation", label: "Out of office", icon: Plane, view: VacationSection },
  { id: "security", label: "Security", icon: ShieldCheck, view: SecuritySection },
  { id: "keyboard", label: "Keyboard shortcuts", icon: Keyboard, view: KeyboardSection },
  { id: "mail-health", label: "Mail health", icon: Activity, view: MailHealthSection, admin: true },
];

export function SettingsView() {
  const { section } = useParams({ strict: false }) as { section?: string };
  const admin = Boolean(useSession().data?.user.admin);
  const sections = SECTIONS.filter((x) => !("admin" in x) || admin);
  const current = sections.find((x) => x.id === section) ?? sections[0]!;
  const View = current.view;
  return (
    <div className={s.surface}>
      <nav className={s.nav} aria-label="Settings sections">
        <h1 className={s.navTitle}>Settings</h1>
        {sections.map((x) => (
          <Link key={x.id} to="/settings/$section" params={{ section: x.id }} className={clsx(s.navItem, x.id === current.id && s.navActive)} aria-current={x.id === current.id ? "page" : undefined}>
            <x.icon aria-hidden />
            <span>{x.label}</span>
          </Link>
        ))}
      </nav>
      <div className={s.content}>
        <div className={s.inner}>
          <h2 className={s.title}>{current.label}</h2>
          <View />
        </div>
      </div>
    </div>
  );
}
